import { useContext } from 'react';
import { AuthContext } from '@urbanx/agx.auth.client';
import { requestGetFileLink, useUploadFile } from 'components/ui-components/File/fileApi';
import { openFileInNewTab } from 'utils/openFileInNewTab';
import { Breakpoints, ScreenSize } from 'utils/screen';

export const useCampaignFileUploadProps = ({ contractId }: { contractId?: string }) => {
  const { getAuthToken } = useContext(AuthContext);
  const uploadFile = useUploadFile();
  const isDesktop = ScreenSize() === Breakpoints.Desktop;

  const uploadCampaignFile = (
    ...[
      authToken,
      file,
      campaignId,
      documentType,
      onUploadProgressChanged,
      abortSignal,
    ]: Parameters<typeof uploadFile>
  ) =>
    uploadFile(authToken, file, campaignId, documentType, {
      contractId,
      onUploadProgressChanged,
      abortSignal: abortSignal ?? undefined,
    });

  return {
    getAuthToken,
    uploadFile: uploadCampaignFile,
    getFileLink: requestGetFileLink,
    onOpenFile: (fileLink: string) => {
      void openFileInNewTab(isDesktop, fileLink);
    },
  };
};
